import axiosInstance from './axiosInstance';

// Reuses the same login.php endpoint the driver app uses.
// user_type is 'dispatcher' or 'admin' here instead of 'driver'.
export async function loginRequest(email, password, userType = 'dispatcher') {
  const response = await axiosInstance.post('/auth/login.php', {
    email,
    password,
    user_type: userType,
  });
  return response.data; // { success, token, user }
}
